import { Components, Theme } from '@mui/material/styles';

export const muiTabsOverride: Components<Theme>['MuiTabs'] = {
  styleOverrides: {
    root: {
      minHeight: 38,
    },
    indicator: {
      height: 2,
    },
  },
};
